import { Environment } from './hooks/useEnvironment';

export const webEnvironment: Environment = 'prod';
